import { calcularDataLimite } from "@/modules/recursos/equipe-obra.rules";
import { useMemo, useRef } from "react";
import type { SearchMenuHandle } from "@/ds";
import type { AdicionarPapelProps } from "./types-adicionar-papel";

export function useAdicionarPapel({
  papeis,
  periodo,
  temLinhas,
  disabled,
  onAdicionar,
}: AdicionarPapelProps) {
  const menu = useRef<SearchMenuHandle>(null);
  const botao = useRef<HTMLElement | null>(null);

  const entradas = useMemo(
    () => papeis.map((papel) => ({ id: papel.id, label: papel.nome })),
    [papeis],
  );

  function escolher(id: string) {
    const papel = papeis.find((candidato) => candidato.id === id);
    if (papel) onAdicionar(papel);
  }

  return {
    menu,
    botao,
    entradas,
    escolher,
    itens: papeis.map((papel) => ({
      id: papel.id,
      nome: papel.nome,
      testId: `equipe-obra-papel-option-${papel.id}`,
      // Obrigatório com período definido: o rótulo do prazo (`null` quando não há tag nem dica).
      prazoRotulo:
        papel.obrigatorio && periodo
          ? (calcularDataLimite(papel.janela, periodo.inicio, periodo.fim)?.rotulo ?? null)
          : null,
    })),
    temLinhas,
    disabled,
  };
}
